<template>
  <div>
    <signature-layout
      :submitSignature="sign"
      :signatureId="signatureId"
      :isLoading="isLoading"
      :foundRequest="found"
      :errorMessage="errorMessage"
      :workflowGuid="registration.workflowGuid"
      :submittedAt="registration.submittedAt"
    >
      <span slot="title">Kennel Name Registration Application</span>
      <div slot="approvedContent">
        <h3 class="mt-5"><b>First choice: </b> {{ registration.firstName }}</h3>
        <h3><b>Second choice: </b> {{ registration.secondName }}</h3>

        <div class="mt-5" v-if="!!registration">
          <h3>Co-Owners</h3>
          <CoownersList
            :owners="registration.owners"
            :ownershipType="kennelOwnershipType"
            :hideHeader="true"
          />
        </div>
      </div>
      <div slot="legalText">
        <p class="bottom-text">
          I agree to abide by the <ASCAArtIncLink />, <BylawsLink />, and all
          ASCA Rules and Regulations governing the ASCA Registry and all other
          ASCA programs.
        </p>
      </div>
    </signature-layout>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import SignatureLayout from "@/components/common/SignatureLayout.vue";
import CoownersList, {
  OwnershipType,
} from "@/components/common/CoownersList.vue";
import ASCAArtIncLink from "@/components/common/ASCAArtIncLink.vue";
import BylawsLink from "@/components/common/BylawsLink.vue";

import { UserInfo } from "@/types/User";
import workflowService from "@/services/portal/workflowService";
import { getErrorMessage } from "@/services/errorHandler";

import { KennelRequestCoownerVM } from "@/types/portal/Registration";

export default Vue.extend({
  name: "KennelRequestSignatureForm",
  components: {
    SignatureLayout,
    CoownersList,
    ASCAArtIncLink,
    BylawsLink,
  },
  props: { signatureId: Number },
  data: function () {
    return {
      signatureText: "",
      errorMessage: "",
      registration: <KennelRequestCoownerVM>{},
      isLoading: false,
      found: false,
    };
  },
  created() {
    this.load();
  },
  watch: {
    signatureId: function (newValue) { this.load(); }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    kennelOwnershipType: function () {
      return OwnershipType.Kennel;
    },
  },
  methods: {
    load: async function () {
      this.isLoading = true;
      this.errorMessage = "";
      this.found = false;

      try {
        const response = await workflowService.getKennelRegistrationDetailsForSignature(this.signatureId);
        this.found = response.found;

        if (response.found && (!response.errors || response.errors.length == 0)) {
          this.registration = response.data;
        } else if (!!response.errors) this.errorMessage = response.errors ? response.errors.join(',') : 'An Unknown Error Occured'
      } catch (error) {
        this.errorMessage = getErrorMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    sign: function (workflowGuid: String, signatureId: number, text: String) {
      workflowService
        .signKennelRegistration(workflowGuid, signatureId, text)
        .then((res) => {
          this.$store.dispatch("loadPersonTasks");
          this.$navigate("/");
        }).catch(this.$handleError);
    },
  },
});
</script>
